import React, { Fragment, useEffect, useState } from "react";
import {
  Menu,
  Select,
  Input,
  Space,
  Drawer,
  Dropdown,
  Button,
  Radio,
  Tag,
  Row,
  Switch,
  Pagination,
  Col,
  Typography,
  AutoComplete,
  Modal,
  Form,
  Checkbox,
} from "antd";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchKeySearchDynamicLocation,
  fetchKeySearchLocation,
  keySearchMyGigsLocation,
} from "../../../../redux/actions";
import _ from "lodash";

const PARAM_KEYS = {
  city: "location",
  state: "region",
  country: "country",
};

const OTHER_FILTERS = {
  BudgetMax: null,
  BudgetMin: null,
  BudgetType: null,
  CityId: [],
  CountryId: [],
  Experience: [],
  GigType: null,
  Latitude: null,
  Longitude: null,
  NearBy: null,
  ProfessionCode: null,
  RegionId: [],
  SkillsId: [],
  hide: true,
  maxDistance: "50",
  search: "",
  searchType: "Skills",
  _page: 1,
  _perPage: "24",
  _sort: "MOST_RELEVANT",
};

const SearchDropDown = ({
  isSelected,
  label,
  paramKey = "location",
  searchFilters = {},
  filterKey,
  handleApply,
  isMobileView = false,
  selectedOptions,
  setSelectedOptions,
  drawerTitle = "",
  searchText = "",
  defaultParams={}
}) => {
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  // const {
  //   locations,
  //   regionSuggestions,
  //   stateSuggestions: countries,
  // } = useSelector((state) => state.searchSkillListingReducer);
  const {
    locations,
    regionSuggestions,
    stateSuggestions: countries,
    ...rest
  } = useSelector((state) => state.myGigsFilterReducer);

  const [isOpen, setIsOpen] = useState(false);
  const [isError, setIsError] = useState(true);
  const [list, setList] = useState([]);

  const handleOpen = (e) => {
    try {
      setSearchValue("");
      setIsOpen(e);
      setSelectedOptions((prev) =>
        prev.filter((el) => searchFilters?.[filterKey]?.includes(getItemId(el)))
      );
      handleSearch({ target: { value: "" } });
    } catch {}
  };

  const handleDebounceSearch = _.debounce((params) => {
    dispatch(keySearchMyGigsLocation(params));
  }, 500);

  const handleSearch = ({ target: { value } }) => {
    setSearchValue(value);
    const query = `${paramKey}=${value || ""}`;
    const params = {
      value: value ? query : null,
      body: { ...searchFilters, all: searchText || "",...defaultParams },
    };
    handleDebounceSearch(params);
  };

  const onCheckBoxChange = (e) => {
    const item = JSON.parse(e.target.value) || {};
    const itemId = getItemId(item);
    if (e.target.checked)
      setSelectedOptions([...selectedOptions, { ...item, id: itemId }]);
    else setSelectedOptions(selectedOptions.filter((el) => el.id !== itemId));
  };

  const getItemId = (item) => {
    return item?.RegionId || item?.CityId || item?.CountryId;
  };

  const getTitle = (item) => {
    switch (paramKey) {
      case PARAM_KEYS.city:
        return item?._id;
      case PARAM_KEYS.country:
        return item?.CountryName;
      case PARAM_KEYS.state:
        return item?.RegionName;
      default:
        return "";
    }
  };

  const onClickApply = () => {
    setIsOpen(false);
    handleApply([...selectedOptions.map((el) => el.id)], filterKey, [
      ...selectedOptions.map((el) => ({
        title: getTitle(el),
        filterKey,
        id: getItemId(el),
      })),
    ]);
  };

  const onClickClear = () => {
    setIsOpen(false);
    setSelectedOptions([]);
    handleApply([], filterKey, []);
    setSearchValue("");
  };

  const getUpdatedCounts = (option) => {
    return list.find((el) => getTitle(el) == getTitle(option))?.count || 0;
  };

  const locationMenu = (
    <div className="location-suggestion-view">
      <Input
        onChange={handleSearch}
        className="filter-search-input"
        placeholder="Search"
        value={searchValue}
        prefix={<SearchOutlined />}
      />
      <Space
        direction="vertical"
        className={"infinite-scroller mobile-no-scroller"}
        style={{  width: "103%", paddingRight: "8px" }}
      >
         <div
          className={`location-lists-container ${
            list?.length > 5 ? "show-scrollbar" : ""
          }`}
          style={{ maxHeight: "250px" }}  
        >
          {selectedOptions.map((items, index) => {
            return (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  marginTop: index === 0 ? "0px" : "10px",
                }}
                key={index}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "inherit",
                  }}
                >
                  <Checkbox
                    key={index}
                    value={JSON.stringify(items)}
                    onChange={onCheckBoxChange}
                    checked={true}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {" "}
                      <div>{getTitle(items)}</div>
                    </div>
                  </Checkbox>
                  {/* <>
                    {" "}
                    <div className="countDiv">
                      ({getUpdatedCounts(items)})
                    </div>{" "}
                  </> */}
                </div>
              </div>
            );
          })}
          {list?.length ? (
            <>
              {list
                .filter(
                  (item) =>
                    selectedOptions.findIndex(
                      (el) => el.id == getItemId(item)
                    ) < 0
                )
                .map((items, index) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "10px",
                      }}
                      key={index}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "inherit",
                        }}
                      >
                        <Checkbox
                          type={"radio"}
                          key={index}
                          value={JSON.stringify(items)}
                          className="location-radio"
                          onChange={onCheckBoxChange}
                          checked={false}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            {" "}
                            <div>{getTitle(items)}</div>
                          </div>
                        </Checkbox>
                        {/* <>
                          {" "}
                          <div className="countDiv">({items?.count})</div>{" "}
                        </> */}
                      </div>
                    </div>
                  );
                })}
            </>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                color: "#7e7e7e",
              }}
            >
              {" "}
              No results found{" "}
            </div>
          )}
        </div>
      </Space>
    </div>
  );

  useEffect(() => {
    setList(
      paramKey == PARAM_KEYS.city
        ? locations
        : paramKey == PARAM_KEYS.country
        ? countries
        : regionSuggestions
    );
  }, [locations, countries, regionSuggestions]);

  // Mobile Filter

  const [isShowDrawer, setIsShowDrawer] = useState(false);

  const handleDeselect = (item) => {
    const filteredData = selectedOptions.filter((el) => getTitle(el) !== item);
    setSelectedOptions(filteredData);
    handleApply(
      filteredData.map((el) => el.id),
      filterKey,
      [
        ...filteredData.map((el) => ({
          title: getTitle(el),
          filterKey,
          id: getItemId(el),
        })),
      ]
    );
  };
  const onCloseDrawer = () => {
    setIsShowDrawer(false);
    onClickApply();
  };

  const containerStyle = {
    position: "relative",
    height: "100vh !important",
    overflow: "hidden",
    // textAlign: 'center',
  };
  if (isMobileView) {
    return (
      <Fragment>
        <Drawer
          className="location-drawer"
          onClose={onCloseDrawer}
          visible={isShowDrawer}
          closable={true}
          placement={"top"}
          // afterOpenChange={(e) => {
          //   handleCountryChange(e);
          // }}
          contentWrapperStyle={containerStyle}
          title={drawerTitle}
        >
          {locationMenu}
        </Drawer>
        <Form>
          <Form.Item>
            <Select
              value={selectedOptions.map((el) => getTitle(el))}
              placeholder={"Search " + label}
              className="input"
              mode="multiple"
              bordered={false}
              onDeselect={handleDeselect}
              onClick={() => {
                setSearchValue("");
                setIsShowDrawer(true);
                handleSearch({ target: { value: "" } });
              }}
              showSearch
              listHeight={160}
              open={false}
            ></Select>
          </Form.Item>
        </Form>
      </Fragment>
    );
  }

  const getWebMenu = () => {
    return (
      <Menu
        className={`location-filter-menu ${
          isError === "city" && "filterError"
        }`}
      >
        <div className="location-filter-menu-inner">
          {locationMenu}
          <ActionButtons
            onClickApply={onClickApply}
            onClickClear={onClickClear}
          />
        </div>
      </Menu>
    );
  };

  return (
    <Dropdown
      overlayClassName="searchResultsFilterDropdown"
      overlay={getWebMenu()}
      trigger="click"
      open={isOpen}
      onOpenChange={handleOpen}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
    >
      <Button
        className={
          isSelected > 0 ? "visaStatus-dropdown-select" : "visaStatus-dropdown"
        }
      >
        {label} <DownOutlined />
      </Button>
    </Dropdown>
  );
};

const ActionButtons = ({ onClickClear, onClickApply }) => {
  return (
    <div style={{ paddingRight: "5px" }}>
      <div className="clearAll-div">
        <div className="cancelfilter-btn" onClick={onClickClear}>
          Clear all
        </div>
        <button className="applyfilter-btn" onClick={onClickApply}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default SearchDropDown;
